<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			:max-width="536"
			:is-confirmar-visivel="true"
			:custom-actions="false"
			:acao-cancelar="cancelar"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Salvar"
			:is-confirmar-desabilitado="!formIsValid"
			@close="cancelar"
		>
			<template #body>
				<v-row class="mt-1">
					<v-col cols="12">
						<label-personalizado
							nome-campo="Título"
							obrigatorio-por-padrao
							class="mb-2"
						></label-personalizado>
						<v-text-field
							v-model="tituloTipoDocumento"
							id="novo-tipo-titulo"
							placeholder="Informe"
							type="string"
							clearable
							counter="100"
							:rules="regrasTituloTipoDocumento"
							class="ma-0 py-0"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" sm="4">
						<label-personalizado
							nome-campo="Área Pública"
							apresenta-tooltip
							mensagem-padrao-tooltip="A configuração deste tipo de documento como obrigatório, será destinado a anexos, especificamente na área pública."
						></label-personalizado>
						<v-radio-group v-model="areaPublica" row class="pa-0 mt-6" @change="alterouAreaPublica">
							<v-radio label="Sim" value="SIM"></v-radio>
							<v-radio label="Não" value="NAO"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col cols="12" sm="4" v-if="areaPublica === 'SIM'">
						<label-personalizado nome-campo="Obrigatório"></label-personalizado>
						<v-radio-group v-model="areaPublicaObg" row class="pa-0 mt-6">
							<v-radio label="Sim" value="SIM"></v-radio>
							<v-radio label="Não" value="NAO"></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
				<v-row v-if="isEditar">
					<v-col cols="12">
						<label-personalizado nome-campo="Situação?" obrigatorio-por-padrao></label-personalizado>
						<v-radio-group v-model="situacao" row class="pa-0 mt-6">
							<v-radio label="Ativo" value="ATIVO"></v-radio>
							<v-radio label="Inativo" value="INATIVO"></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>

<script>
import Modal from '@/views/components/Modal.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'

export default {
	name: 'modal-tipo-documento',
	components: { LabelPersonalizado, Modal },
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
		tipoDocumento: {
			type: Object,
			default: () => {
				return {
					id: null,
				}
			},
		},
	},
	data() {
		return {
			formIsValid: false,
			tituloTipoDocumento: '',
			regrasTituloTipoDocumento: [
				(value) => this.regraObrigatoriedade(value, 'Campo obrigatório!'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						100,
						'O campo de título deve ser menor ou igual do que 100 caracteres!',
					),
			],
			areaPublica: 'NAO',
			areaPublicaObg: 'NAO',
			situacao: 'ATIVO',
		}
	},
	computed: {
		isEditar() {
			return !!this.tipoDocumento.id
		},
		tituloModal() {
			return this.isEditar ? 'Editar Tipo de Documento' : 'Novo Tipo de Documento'
		},
	},
	mounted() {
		this.setTipoEdicao()
	},
	methods: {
		confirmar() {
			if (this.$refs.form.validate()) {
				this.$emit('confirmar', this.getTipoDocumento())
			}
		},
		getTipoDocumento() {
			const tipoDocumento = {
				nome: this.tituloTipoDocumento,
				areaPublica: this.areaPublica,
				areaPublicaObg: this.areaPublicaObg,
			}

			if (this.isEditar) {
				tipoDocumento.id = this.tipoDocumento.id
				tipoDocumento.situacao = this.situacao
			}

			return tipoDocumento
		},
		cancelar() {
			this.limparTipoDocumento()
			this.$emit('fechar-modal')
		},
		limparTipoDocumento() {
			this.tituloTipoDocumento = ''
			this.areaPublica = 'NAO'
			this.areaPublicaObg = 'NAO'
		},
		alterouAreaPublica(value) {
			if (value === 'NAO') {
				this.areaPublicaObg = 'NAO'
			}
		},
		setTipoEdicao() {
			if (this.isEditar) {
				this.tituloTipoDocumento = this.tipoDocumento.nome
				this.areaPublica = this.tipoDocumento.areaPublica
				this.areaPublicaObg = this.tipoDocumento.areaPublicaObg
				this.situacao = this.tipoDocumento.situacao
			}
		},
	},
}
</script>

<style scoped lang="stylus"></style>
